import { PageContainer } from '@/components';

const NoModule: React.FC<any> = () => {
  return (
    <PageContainer title="ماژولی یافت نشد">
      <h2>ماژولی برای شما فعال نیست</h2>
    </PageContainer>
  );
};

export default NoModule;
